<claas-dialog-modal
  [title]="'changeLanguageDialog.title' | translate"
  [showCloseButton]="false"
  [isModal]="true"
  [size]="modalSize"
>
  <div class="language-list">
    @for (lang of store.availableLanguages(); track lang) {
      <button
        type="button"
        class="language-item"
        [class.language-item--selected]="lang === selectedLanguage()"
        (click)="select(lang)"
      >
        {{ "language." + lang | translate }}
      </button>
    }
  </div>
  <div class="dialog-footer">
    <claas-button
      [buttonClass]="buttonClass.SECONDARY_OUTLINE"
      (click)="cancel()"
      >{{ "dialogButtons.cancel" | translate }}</claas-button
    >
    <claas-button [buttonClass]="buttonClass.PRIMARY" (click)="confirm()">{{
      "dialogButtons.confirm" | translate
    }}</claas-button>
  </div>
</claas-dialog-modal>
